@if (formValueChanges$ | async) {}

<app-slide-overlay-header
  icon="select_check_box"
  [title]="title()"
  [canDelete]="hasEntitiesWriteAccess"
  [canArchive]="hasEntitiesWriteAccess"
>
  @if (displayPrintReportOption()) {
    <app-dropdown-menu-item additional-options (pressed)="onClickGoToPrintView()">
      <mat-icon>quick_reference</mat-icon>
      <ng-container i18n="@@title.printreport">Print report</ng-container>
    </app-dropdown-menu-item>
  }
</app-slide-overlay-header>

<app-slide-overlay-content #slideOverlayContent contentClass="full-height">
  <ng-template
    [overlay-menu-tab]="overlayTabEnum.DETAILS"
    appSlideOverlayMenuItem
    overlay-menu-icon="info"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.DETAILS).title"
    [overlay-menu-tag]="completedIndicatorsCount()"
    [overlay-menu-tooltip]="indicatorsCountTooltip"
  >
    <div [formGroup]="form" class="full-height full-width">
      <div class="content-container">
        <div class="content-container__left">
          @for (group of form.controls.indicators.controls; track group; let index = $index) {
            @let isNewCategory =
              group.value._indicatorGroup.name &&
              group.value._indicatorGroup.name !==
                form.controls.indicators.controls[index - 1]?.value._indicatorGroup.name;

            <div [formGroup]="group">
              @if (isNewCategory) {
                <h4>{{ group.value._indicatorGroup.name }}</h4>
              }

              <app-risk-assessment-report-overlay-indicator-card
                [noteControl]="group.controls.note"
                [indicator]="group.value._indicator"
                [isStatusLoading]="group.value._isIndicatorStatusLoading"
                [mitigations]="group.value._mitigations"
                [position]="index + 1"
                (saveNote)="saveNote($event)"
                (addMitigation)="onAddIndicatorMitigation($event)"
                (removeMitigation)="onRemoveIndicatorMitigation($event)"
                (updateMitigationStatus)="onUpdateIndicatorMitigationStatus($event)"
                (resetResponse)="resetIndicatorResponse($event)"
                (statusChange)="onIndicatorRiskStatusChange($event)"
                (openMitigationsPanel)="openMitigationsPanel(index)"
              />
            </div>
          }
        </div>

        @if (!overlay.contentRightSidePanel()) {
          <div class="content-container__right">
            <app-input-select
              formControlName="status"
              [label]="translations.statusLabel"
              enableViewMode
              [options]="statusOptions"
            />

            @if (overlay.editMode()) {
              <app-input-select
                formControlName="calculatedRisk"
                [label]="translations.calculatedRiskLabel"
                enableViewMode
                [options]="riskLevelOptions()"
                [prefixTemplate]="colorBox"
              />

              <app-input-select
                formControlName="residualRisk"
                [label]="translations.residualRiskLabel"
                enableViewMode
                [options]="riskLevelOptions()"
                [prefixTemplate]="colorBox"
              />
            } @else {
              <div class="form-field-item">
                <app-form-label [label]="translations.calculatedRiskLabel" />
                <app-basic-tags [tags]="element.calculatedRisk ? [element.calculatedRisk] : []" />
              </div>

              <div class="form-field-item">
                <app-form-label [label]="translations.residualRiskLabel" />
                <app-basic-tags [tags]="element.residualRisk ? [element.residualRisk] : []" />
              </div>
            }

            <app-datepicker
              formControlName="completedDate"
              [label]="translations.completedDateLabel"
              enableViewMode
            />

            <app-datepicker
              formControlName="validUntilDate"
              [label]="translations.validUntilDateLabel"
              enableViewMode
              [minDate]="form.controls['completedDate'].value"
            />

            <app-editable-div
              formControlName="note"
              [label]="translations.noteLabel"
              class="bordered"
              [placeholder]="translations.notePh"
              hintErrorClass="initial"
              [isTextarea]="true"
              [isOptional]="true"
              [enableViewMode]="overlay.viewMode()"
            />

            @if (element && isRegularUser && overlay.viewMode()) {
              <app-record-details [element]="element" />
            }
          </div>
        }
      </div>
    </div>
  </ng-template>
  <ng-template
    appSlideOverlayMenuItem
    overlay-menu-icon="quick_reference_all"
    [overlay-menu-tab]="overlayTabEnum.REFERENCED_RISK_ASSESSMENT_REPORTS"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.REFERENCED_RISK_ASSESSMENT_REPORTS).title"
    [overlay-menu-indicator]="element?.referencedReports?.length"
    [overlay-menu-buttons-template]="referencesController"
    [overlay-menu-show-edit-button]="false"
    [overlay-menu-show-save-button]="false"
  >
    <app-risk-assessment-report-overlay-references
      #referencesView
      [reportUris]="element?.referencedReports"
      [canEdit]="canEditReferences"
      [type]="typeQueryParam"
      [entityId]="entityIdQueryParam"
      (referenceReport)="onReferenceReport($event)"
    />
  </ng-template>
</app-slide-overlay-content>

<ng-template #colorBox let-option>
  <div [class]="option.value" class="color-box"></div>
</ng-template>

<ng-template #mitigationsPanel>
  <app-overlay-risk-mitigations-right-panel
    [saveToMitigationsListOption]="true"
    (add)="onAddIndicatorMitigation($event)"
  />
</ng-template>

<ng-template #referencesController>
  @if (!overlay.contentRightSidePanel() && canEditReferences) {
    <app-button-group>
      @if (referencesView?.allRelatedReportUris().length) {
        <app-button
          type="ghost"
          [disabled]="overlay.loading()"
          (pressed)="onAddAllRelatedReports()"
        >
          <mat-icon class="action-icon" icon-left>wand_stars</mat-icon>
          <ng-container>{{ translations.addallsuggested }}</ng-container>
        </app-button>
      }
      <app-button
        type="ghost"
        [disabled]="overlay.loading()"
        (pressed)="overlay.openSideMenu(referencesView?.reportsPanel())"
      >
        <mat-icon class="action-icon" icon-left>add</mat-icon>
        <ng-container i18n="@@action.add">Add</ng-container>
      </app-button>
    </app-button-group>
  }
</ng-template>
